export let imgs = [
    require('@/assets/images/ipad/dazzle-s.jpg'),
    require('@/assets/images/ipad/dazzle.jpg'),
    require('@/assets/images/ipad/enjoy-safety.jpg'),
    require('@/assets/images/ipad/enjoy.jpg'),
    require('@/assets/images/ipad/environment.jpg'),
    require('@/assets/images/ipad/home.jpg'),
    require('@/assets/images/ipad/selected.jpg'),
    require('@/assets/images/ipad/signal-animation-s.png'),
    require('@/assets/images/ipad/signal-animation.png'),
    require('@/assets/images/ipad/signal.jpg'),
    require('@/assets/images/ipad/ultraviolet-s.png'),
    require('@/assets/images/ipad/ultraviolet.jpg'),
    require('@/assets/images/ipad/vehicle-safety.jpg'),
    require('@/assets/images/ipad/warranty.jpg'),
    require('@/assets/images/mobile/Dazzle-icon.png'),
    require('@/assets/images/mobile/Environment-icon.png'),
    require('@/assets/images/mobile/Signal-icon.png'),
    require('@/assets/images/mobile/Ultraviolet-icon.png'),
    require('@/assets/images/mobile/Warranty-icon.png'),
    require('@/assets/images/mobile/arrow.png'),
    require('@/assets/images/mobile/clone.png'),
    require('@/assets/images/mobile/dazzle-s.jpg'),
    require('@/assets/images/mobile/dazzle-tishi.png'),
    require('@/assets/images/mobile/dazzle-txt.png'),
    require('@/assets/images/mobile/dazzle.jpg'),
    require('@/assets/images/mobile/enjoy-safety.jpg'),
    require('@/assets/images/mobile/enjoy.jpg'),
    require('@/assets/images/mobile/environment-tishi.png'),
    require('@/assets/images/mobile/environment.jpg'),
    require('@/assets/images/mobile/home-text.png'),
    require('@/assets/images/mobile/home.jpg'),
    require('@/assets/images/mobile/insulation-icon.png'),
    require('@/assets/images/mobile/insulation-tishi.png'),
    require('@/assets/images/mobile/insulation-txt.png'),
    require('@/assets/images/mobile/insulation.jpg'),
    require('@/assets/images/mobile/insulation1.jpg'),
    require('@/assets/images/mobile/leaf1.png'),
    require('@/assets/images/mobile/leaf2.png'),
    require('@/assets/images/mobile/leaf3.png'),
    require('@/assets/images/mobile/membrane.png'),
    require('@/assets/images/mobile/menu-bg.jpg'),
    require('@/assets/images/mobile/selected.jpg'),
    require('@/assets/images/mobile/signal-animation-s.png'),
    require('@/assets/images/mobile/signal-animation.png'),
    require('@/assets/images/mobile/signal-tishi.png'),
    require('@/assets/images/mobile/signal-txt.png'),
    require('@/assets/images/mobile/signal.jpg'),
    require('@/assets/images/mobile/skider.png'),
    require('@/assets/images/mobile/slider.jpg'),
    require('@/assets/images/mobile/ultraviolet-s.png'),
    require('@/assets/images/mobile/ultraviolet.jpg'),
    require('@/assets/images/mobile/vehicle-safety.jpg'),
    require('@/assets/images/mobile/warranty-tishi.png'),
    require('@/assets/images/mobile/warranty.jpg'),
    require('@/assets/images/vertical-plate.jpg'),
    require('@/assets/images/vertical-screen-text.png'),
    require('@/assets/images/load.png'),
    require('@/assets/images/logo.jpg'),
];
